import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import adminpage_ko from '../i18n/locales/ko/adminpage.json'
import adminpage_en from '../i18n/locales/en/adminpage.json'
import menubar_ko from '../i18n/locales/ko/menubar.json'
import menubar_en from '../i18n/locales/en/menubar.json'
import map_ko from '../i18n/locales/ko/map.json'
import map_en from '../i18n/locales/en/map.json'
import utils_ko from '../i18n/locales/ko/utils.json'
import utils_en from '../i18n/locales/en/utils.json'



i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        menubar: menubar_en,   // ✅ 네임스페이스 이름을 key로 사용
        adminpage: adminpage_en,
        map: map_en,
        utils: utils_en,
       

      },
      ko: {
        menubar: menubar_ko,   // ✅ 동일하게 맞춤
        adminpage: adminpage_ko,
        map: map_ko,
        utils: utils_ko,
      
      }
    },
    fallbackLng: 'ko',
    ns: ['menubar','adminpage', 'map'],       // ✅ 실제 네임스페이스와 일치
    defaultNS: '',  // ✅ 기본 네임스페이스도 맞춰줌
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
